<!-- 1: Portfolio Hero Section -->
<section class="portfolio-section py-5">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 order-1 order-lg-1">
        <h1 class="fw-bold section-title">
          MALtech Portfolio - Proven Software Development Projects and Digital
          Solutions
        </h1>
        <p class="section-subtitle para px-2">
          At MALtech, we transform ideas into scalable IT solutions. From Cloud
          and AI to DevOps, Cybersecurity, and Software Consulting, our
          portfolio showcases innovation, reliability, and global trust.
        </p>
        <div class="text-lg-start text-center">
          <a
            routerLink="/contact"
            href="/contact"
            class="btn btn-portfolio rounded-pill px-4"
          >
            Work Together
          </a>
        </div>

      </div>
      <div class="col-lg-6 text-center order-2 order-lg-2 mt-5">
        <img
          src="/assets/images/portfolio/first.webp"
          alt="Future of Technology"
          class="img-fluid portfolio-image"
          loading="lazy"
        />
      </div>
    </div>
    <div class="row mt-5 text-center g-4">
      <div class="col-12 col-md-6 col-lg-3 mb-0">
        <a
          class="card service-card h-100 text-decoration-none text-reset d-block"
          routerLink="/service/software-development/"
          href="/service/software-development/"
        >
          <div class="icon mb-3"><i class="bi bi-code-slash"></i></div>
          <h5 class="fw-bold">Software Development</h5>
          <p class="para">
            We design and build powerful web, mobile, and enterprise
            applications that are user-friendly, scalable, and tailored to your
            business goals.
          </p>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-0">
        <a
          class="card service-card h-100 text-decoration-none text-reset d-block"
          routerLink="/service/software-consulting-services/"
          href="/service/software-consulting-services/"
        >
          <div class="icon mb-3"><i class="bi bi-people"></i></div>
          <h5 class="fw-bold">Software Consulting</h5>
          <p class="para">
            Strategic guidance, architecture planning, and optimization to help
            organizations choose the right technologies and maximize ROI.
          </p>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-0">
        <a
          class="card service-card h-100 text-decoration-none text-reset d-block"
          routerLink="/service/software-development/"
          href="/service/software-development/"
        >
          <div class="icon mb-3"><i class="bi bi-cloud"></i></div>
          <h5 class="fw-bold">DevOps & Cloud</h5>
          <p class="para">
            From CI/CD pipelines to cloud deployment, we deliver scalable
            infrastructure on AWS and Azure.
          </p>
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 mb-0">
        <a
          class="card service-card h-100 text-decoration-none text-reset d-block"
          routerLink="/service/digital-marketing/"
          href="/service/digital-marketing/"
        >
          <div class="icon mb-3"><i class="bi bi-megaphone"></i></div>
          <h5 class="fw-bold">Digital Marketing</h5>
          <p class="para">
            SEO, content marketing, social media, and analytics strategies to
            maximize reach and conversions.
          </p>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- 2: Find Out More About Us -->
<section class="about-section py-3" id="open-roles">
  <div class="container">
    <h2 class="about-title text-center text-logo-color">
      Find Out More About Us
    </h2>
    <p class="about-description para px-2">
      At MALtech, we are more than just an IT solutions company we are your
      strategic technology partner. With expertise in Cloud, Al, DevOps,
      Cybersecurity, and Software Consulting. we deliver solutions that empower
      businesses to innovate and scale. Our approach combines cutting-edge
      technology with a people-first culture, ensuring both technical excellence
      and collaboration. By focusing on scalability, security, and user-centric
      design, we help organizations achieve sustainable growth. Together, we
      transform ideas into impactful, future-ready solutions trusted by clients
      worldwide.
    </p>
    <div class="row mt-4 g-4">
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/software.webp"
            alt="Software Development"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Software Development</h5>
          <p class="about-card-text mb-0 para">
            Our experts architect scalable systems and build solutions using
            modern frameworks like Angular, .NET, and Python.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/consulting.webp"
            alt="Software Consulting"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Software Consulting</h5>
          <p class="about-card-text mb-0 para car">
            We begin by listening, analyzing, and mapping your exact needs to
            define a clear, customized roadmap.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/cloud.webp"
            alt="DevOps and Cloud"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Devops and cloud</h5>
          <p class="about-card-text mb-0 para">
            With DevOps and CI/CD pipelines, we ensure seamless rollouts with
            minimal downtime and maximum efficiency.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/dm.webp"
            alt="Digital Marketing"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Digital Marketing</h5>
          <p class="about-card-text mb-0 para">
            Comprehensive digital marketing strategies to enhance your online
            presence.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/trans.webp"
            alt="Transactional Emails"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Transactional Emails</h5>
          <p class="about-card-text mb-0 para">
            Deliver secure, real-time messages like OTPs, order updates, and
            alerts with high reliability.
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="about-card card shadow-sm flex-fill text-center p-4">
          <img
            src="/assets/images/portfolio/email.webp"
            alt="Email Validation"
            class="about-card-img img-fluid mb-3 mx-auto d-block"
            loading="lazy"
          />
          <h5 class="fw-bold mb-2 about-card-title">Email Validation</h5>
          <p class="about-card-text mb-0 para">
            Ensure accurate, verified email addresses to improve deliverability
            and reduce bounce rates.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- 3: Our Approach -->
<section class="approach-section py-3">
  <div class="container">
    <h2 class="approach-title text-center text-logo-color">Our Approach</h2>
    <p class="approach-description para px-2 ">
      At MALtech, our approach is centered around understanding your unique
      business needs and aligning them with the right technology strategies. We
      design scalable, secure, and future-ready solutions tailored to achieve
      long-term success. With an agile process, we ensure flexibility, faster
      delivery, and continuous improvements at every stage. By combining
      innovation, expertise, and creativity, we deliver impactful results that
      empower businesses to grow and transform.
    </p>
    <div class="row approach-steps-row justify-content-center mt-5 g-4">
      <div class="col-12 col-md-6 col-lg-3 d-flex">
        <a
          class="approach-step w-100 text-center text-decoration-none d-block"
          routerLink="/service/software-consulting-services/"
          href="/service/software-consulting-services/"
        >
          Consultation &amp; Discovery
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 d-flex">
        <a
          class="approach-step w-100 text-center text-decoration-none d-block"
          routerLink="/service/software-development/"
          href="/service/software-development/"
        >
          Design &amp; Development
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 d-flex">
        <a
          class="approach-step w-100 text-center text-decoration-none d-block"
          routerLink="/service/software-development/"
          href="/service/software-development/"
        >
          Deployment &amp; Integration
        </a>
      </div>
      <div class="col-12 col-md-6 col-lg-3 d-flex">
        <a
          class="approach-step w-100 text-center text-decoration-none d-block"
          routerLink="/contact"
          href="/contact"
        >
          Support &amp; Growth
        </a>
      </div>
    </div>
  </div>
</section>

<!-- 4: Technologies in Action -->
<section class="tech-section py-3">
  <div class="container">
    <h2 class="tech-title text-center text-logo-color">
      Technologies in Action
    </h2>
    <p class="tech-description mb-4 para px-2">
      At MALtech, we don't just adopt technologies-we bring them to life. Our
      team leverages cutting-edge tools like Angular, NET, WordPress, Python,
      and Flutter to build modem applications across web and mobile platforms.
      With robust cloud services powered by AWS and Azure, combined with secure
      databases like SQL and MongoDB, we ensure performance, scalability, and
      reliability. Through DevOps practices, automation, and continuous
      delivery, we integrate these technologies seamlessly, enabling businesses
      to innovate faster and operate smarter.
    </p>
    <div class="row g-4">
      <!-- Angular -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/angular.webp"
            alt="Angular"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            Angular is a robust front-end framework for creating dynamic,
            scalable web applications. MALtech uses Angular to build secure,
            responsive, and high-performance digital solutions.
          </p>
        </div>
      </div>
      <!-- .Net -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/dotnet.webp"
            alt=".NET"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            .NET is a powerful framework for developing secure, scalable, and
            enterprise-grade applications. MALtech leverages .NET to build
            robust software solutions tailored to complex business needs.
          </p>
        </div>
      </div>
      <!-- Flutter -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/flutter.webp"
            alt="Flutter"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            Flutter is a cross-platform framework for building mobile and web
            applications with a single codebase. MALtech uses Flutter to deliver
            fast, scalable, and seamless user experiences across devices.
          </p>
        </div>
      </div>
      <!-- Python -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/python.webp"
            alt="Python"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            Python is a versatile programming language known for efficiency,
            flexibility, and AI/ML capabilities. MALtech uses Python to build
            intelligent, data-driven, and scalable applications.
          </p>
        </div>
      </div>
      <!-- WordPress -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/wp.webp"
            alt="WordPress"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            WordPress is a flexible CMS platform for building websites, blogs,
            and e-commerce solutions. MALtech uses WordPress to deliver
            customizable, secure, and user-friendly digital experiences.
          </p>
        </div>
      </div>
      <!-- DevOps -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/devops.webp"
            alt="DevOps"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            DevOps streamlines software delivery through automation, CI/CD, and
            continuous monitoring. MALtech leverages DevOps to ensure faster
            releases, improved collaboration, and scalable infrastructure.
          </p>
        </div>
      </div>
      <!-- PHP -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/php.webp"
            alt="Php"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            PHP is a widely-used server-side scripting language for building
            dynamic and interactive web applications. MALtech uses PHP to create
            fast, secure, and scalable digital solutions.
          </p>
        </div>
      </div>
      <!-- AWS -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/aws.webp"
            alt="Aws"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            AWS (Amazon Web Services) is a leading cloud platform offering
            scalable infrastructure, storage, and computing power. MALtech uses
            AWS to deliver secure, scalable, and future-ready cloud solutions.
          </p>
        </div>
      </div>
      <!-- Database -->
      <div class="col-12 col-md-6 col-lg-4 d-flex">
        <div class="tech-card card shadow-sm text-center flex-fill p-4">
          <img
            src="/assets/images/portfolio/db.webp"
            alt="Database"
            class="tech-img mb-3 mx-auto d-block"
            loading="lazy"
          />

          <p class="tech-card-text para">
            Databases provide secure, efficient storage and management of
            business data, both structured and unstructured. MALtech leverages
            SQL and MongoDB for scalable, reliable, and high-performance
            applications.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- 5: FAQ and Contact Section -->

<section class="faq-contact-section py-3">
  <div class="container">
    <h2 class="faq-title text-center text-logo-color">
      Frequently Asked Questions
    </h2>
    <p class="faq-desc text-center para">
      FAQ is a key part of a knowledge base because it addresses the most common
      questions customers have and is useful to customers at all stages of the
      customer journey.
    </p>

    <div class="faq-accordion mx-auto">
      <div class="faq-item" *ngFor="let faq of faqItems; let i = index">
        
        <div class="faq-question-container">
          <button class="faq-question" (click)="toggleFaq(i)">
            {{ faq.question }}
            <span class="faq-chevron" [class.rotate]="faq.open">&#9662;</span>
          </button>

          <div class="faq-answer" [class.open]="faq.open">
            {{ faq.answer }}
          </div>
        </div>

      </div>
    </div>
  </div>
</section>


<section class="faq-contact-section">
  <div>
    <div class="cta-section text-center">
      <h2 class="cta-title">Let's Build the Future Together.</h2>
      <p class="cta-desc para">
        Please get in touch and our expert support team will answer all your
        questions.
      </p>
      <div
        class="cta-box d-flex flex-column flex-md-row justify-content-center align-items-center mx-auto mt-3 gap-2"
      >
        <span class="cta-info text-center text-md-start flex-grow-1 px-2"
          >For more information</span
        >
        <a
          class="btn btn-cta w-100 w-md-auto text-decoration-none"
          [routerLink]="['/contact']"
          [href]="['/contact']"
          aria-label="Contact Us"
        >
          Contact Us
        </a>
      </div>
    </div>
  </div>
</section>
